import { Box, HeroBackground } from "@biom3/react";

export const WeeklyRewardsBackground = () => {
  return (
    <>
      <Box
        sx={{
          mb: {
            default: "0",
            small: "base.spacing.x10",
            large: "base.spacing.x12",
            xLarge: "base.spacing.x16",
            xxxLarge: "base.spacing.x24",
          },
        }}
      >
        <HeroBackground.ZoomText
          textScaleRatio={"1"}
          sx={{
            color: "base.color.fixed.white.1000",
            top: "-8px",
            maxHeight: {
              default: "none",
              xxxLarge: "600px",
            },
          }}
        >
          REWARDS
        </HeroBackground.ZoomText>
      </Box>
    </>
  );
};
